
import { Component, Input, forwardRef } from '@angular/core';
import { ProvidersService } from 'fccore2';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { FcinputComponent } from '../fcinput';
import { FcanyBusiness } from '../business/fcany.business';
/**
 * fc-anyèªå®ä¹ä¸æåé
 * éè¿ç¹å»ä¸æå¤éæ¡å®ç°å¯¹ä¸ç»ç¸å³èçæ°æ®éåè¿è¡å¤ä¸ªéæ©ã
 * å¼¹åºä¸ä¸ªä¸æèåç»ç¨æ·éæ©æä½ï¼ç¨äºä»£æ¿åççéæ©å¨ï¼æèéè¦ä¸ä¸ªæ´ä¼éçå¤éå¨æ¶ã
 * éä¸­çæ¯ä¸ä¸ªå¯¹è±¡ï¼æ ¼å¼æ¯{label:'åå­',value:'name',disabledï¼false}ã
 * äºä»¶ï¼
 * 1.æ¸é¤äºä»¶ï¼clear
 */
@Component({
    selector: 'fc-any',
    template: `
    <nz-select [nzFilterOption]="fcFilterOption" [nzDropdownClassName]="fcDropdownClassName" [nzDropdownStyle]="fcDropdownStyle" #fcany1 *ngIf="fcShowLabel==='N'" 
    [nzDisabled]="_disabled" class="fc-any" [ngClass]="{'fc-readonly':_readonly,'fc-any-small':fcSize === 'small','fc-any-default':fcSize === 'default','fc-any-large':fcSize === 'large'}" 
    [nzShowSearch]="fcShowSearch" (nzOnSearch)="_event('onSearch',$event)" (nzOpenChange)="_event('openChange',$event)" (nzScrollToBottom)="_event('scrollToBottom',$event)" 
     [nzSize]="fcSize" [(ngModel)]="_selectOptions" (ngModelChange)="_event('valueOnChange',$event)" 
    [nzNotFoundContent]="fcNotFoundContent" [nzPlaceHolder]="fcPlaceHolder" [nzAutoFocus]="fcAutoFocus==='Y'"
    [nzAllowClear]="_allowClear" [nzDropdownMatchSelectWidth]="_autoSize" [nzOpen]="_open">
    <nz-option *ngFor="let option of _options" (click)="_event('click',option)"  [nzLabel]="option.label" [nzValue]="option" [nzDisabled]="option.disabled"></nz-option>
    <nz-option *ngIf="fcLoading==='Y'" nzDisabled nzCustomContent>
    <i nz-icon type="loading" class="loading-icon"></i> æ­£å¨å è½½ä¸­...
  </nz-option>
    </nz-select>
    <div nz-row  nzType="flex" class="rowspans"  *ngIf="fcShowLabel===undefined||fcShowLabel==='Y'">
        <div nz-col [nzSpan]="labelSpan" class="labelspans"><span *ngIf="fcRequired==='Y'" style="color:red">*</span>{{fcLabel}}</div>
        <div nz-col [nzSpan]="valueSpan">
            <nz-select #fcany2 class="fc-any" [nzFilterOption]="fcFilterOption" [nzDropdownClassName]="fcDropdownClassName" [nzDropdownStyle]="fcDropdownStyle" 
             [nzDisabled]="_disabled" [nzShowSearch]="fcShowSearch" (nzOpenChange)="_event('openChange',$event)" 
            (nzOnSearch)="_event('onSearch',$event)" (nzScrollToBottom)="_event('scrollToBottom',$event)"  [nzSize]="fcSize" 
            [ngClass]="{'fc-readonly':_readonly,'fc-any-small':fcSize === 'small','fc-any-default':fcSize === 'default','fc-any-large':fcSize === 'large'}" 
            [(ngModel)]="_selectOptions" (ngModelChange)="_event('valueOnChange',$event)" [nzNotFoundContent]="fcNotFoundContent" [nzPlaceHolder]="fcPlaceHolder" 
            [nzAllowClear]="_allowClear" [nzDropdownMatchSelectWidth]="_autoSize" [nzOpen]="_open" [nzAutoFocus]="fcAutoFocus==='Y'">
                <nz-option *ngFor="let option of _options" (click)="_event('click',option)"  [nzLabel]="option.label" [nzValue]="option" [nzDisabled]="option.disabled"></nz-option>
                <nz-option *ngIf="fcLoading==='Y'" nzDisabled nzCustomContent>
                <i nz-icon type="loading" class="loading-icon"></i> æ­£å¨å è½½ä¸­...
                </nz-option>
            </nz-select>
            <div class="fc-help-text" *ngIf="'Y'===fcShowHelp">
                {{fcHelp}}
            </div>
            <div class="explain" *ngIf="_validator!==undefined&&_validator.show==='Y'">
                <div [hidden]="_validator.showValidator!=='required'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.required}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='maxLength'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.maxLength}}</div>
                </div>
                <div [hidden]="_validator.showValidator!=='customVal'" class="explain-inner">
                    <div class="explain-tips">{{_validator.errorMessages.customVal}}</div>
                </div>
            </div>
        </div>
    </div>
  `,
    styles: [`
    .fc-any{
        width:100%
    }
    .ant-select-dropdown-menu-item{
        overflow: visible;
    } 
    .fc-readonly {
        pointer-events: none;
        background:#f5f5f5;
    }
    :host ::ng-deep .fc-readonly .ant-select-selection{
        background: #f5f5f5;
    }
    .fc-disable {
        pointer-events: none;
        cursor:not-allowed;
    }
    :host ::ng-deep .fc-disable .ant-select-selection{
        background: #f5f5f5;
    }
    .form-explain {
        position:relative;
    }
    .explain{
        white-space: nowrap;
        position:absolute;
        right: -1px;
        bottom: 24px;
        z-index:10;
    }
    .explain-inner {
        position:relative;
        color:red;
    }
    .explain-inner:after{
        content: '';
        width: 10px;
        height: 12px;
        display: block;
        background-color: #ffffff;
        border-right: 1px solid #e9e9e9;
        border-bottom: 1px solid #e9e9e9;
        position: absolute;
        bottom: -6px;
        right: 12px;
        transform: rotate(45deg);
        z-index: 0;
    }
    .explain-tips{
        padding: 0px 10px;
        background-color: #ffffff;
        border: 1px solid #e9e9e9;
        border-radius: 4px;
        font-size: 12px;
        height: 30px;
        line-height: 28px;
    }
    :host ::ng-deep .fc-noshowlabel{

    } 
    `],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => FcanyComponent),
        multi: true
    }]
})
/** ä¸æåéå¯¹è±¡  */
export class FcanyComponent extends FcinputComponent {
    @Input()
    fcFilterOption: () => {};
    @Input()
    fcDropdownClassName: string;
    @Input()
    fcDropdownStyle: string;
    // é¦è¡ç©ºè¡
    @Input()
    fcLineOneSpace: string;
    /*æ¯å¦loading */
    @Input()
    fcLoading = 'N';
    /** åéå¼ */
    @Input()
    fcOption: any[];
    //
    _options: any[] = [];
    //
    _selectOptions: any;
    /** æ¯å¦å¯ç¨æç´¢ */
    @Input()
    fcShowSearch: boolean = true;
    /** å½åè¡¨ä¸ºç©ºæ¶æ¾ç¤º */
    @Input()
    fcNotFoundContent: string;
    /** labelå­æ®µåç§° */
    @Input()
    fcLabelCode: string;
    /** valueå­æ®µåç§° */
    @Input()
    fcValueCode: string;
    /** disabledå­æ®µåç§° */
    @Input()
    fcDisabledCode: string;
    /** æ¯å¦æ¯ææ¸é¤ */
    @Input()
    fcAllowClear: string;

    @Input()
    fcAutoFocus: string;
    //
    _allowClear: boolean;
    /** åå®¹ç­å®½ */
    @Input()
    fcAutoSize: string;
    //
    _autoSize: boolean;
    /** æ¯å¦æå¼ä¸æ */
    @Input()
    fcOpen: string;
    //
    _open: boolean;
    constructor(public provider: ProvidersService) {
        super(provider, 'fc-any');
        FcanyBusiness.initData(this, {});
    }
    _afterParentInit(param) {
        if ((param && Object.keys(param).length === 0) || !param) {
            // çæ§æ¯å¦åçå¼åå
            FcanyBusiness.valueChange(this, param);
            return;
        }
        FcanyBusiness.changeOption(this, param);
        /** æ¯å¦æ¯ææ¸é¤ */
        this._allowClear = this.fcAllowClear === "Y";
        /** åå®¹ç­å®½ */
        this._autoSize = this.fcAutoSize === 'N';
        /** æ¯å¦æå¼ä¸æ */
        this._open = this.fcOpen === 'Y';
        /** æ¯å¦ç¦ç¨ */
        this._disabled = this.fcDisabled === 'Y';
        /** æ¯å¦åªè® */
        this._readonly = this.fcReadonly === 'Y';
        // çæ§æ¯å¦åçå¼åå
        FcanyBusiness.valueChange(this, param);
    }
   /**
    * åé¨äºä»¶å¤ç
    * @param eventName äºä»¶
    * @param param åæ°
    */
    _event(eventName: string, $event: any): void {
        switch (eventName) {
            case 'valueOnChange':
                FcanyBusiness.valueOnChange(this, $event);
                break;
            case 'scrollToBottom':
                super.event('scrollToBottom', this._selectOptions);
                break;
            default:
                super.event(eventName, $event);
        }
    }
}


